import React, { useState } from "react";
import { ButtonGroup } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { MdOutbound, MdWarning } from "react-icons/md";
import { Cash, PersonX } from "react-bootstrap-icons";
import { formatMoney } from "../../../utilities/common";
import Button from "react-bootstrap/Button";

import { TransactionList } from "./TransactionList";

import './PlayerStats.css';
import { useHouseDispatch } from "../../../contexts/HouseContext";

export function PlayerStats({ gameId, player, handleShowAddTransaction }) {
    const actions = useHouseDispatch();

    const [showTransactionList, setShowTransactionList] = useState(false);

    const transactions = player.transactions;

    const playerHasTransactions = transactions.length > 0;

    const totals = player.totals;

    const netColor = player.totals.net >= 0 ? "text-success" : "text-danger"

    const cashOutTxn = transactions.find(t => ["CASH_OUT", "COVER"].includes(t.type));
    const isCashedOut = !!cashOutTxn;

    const unsettledBuyIns = player.transactions
        .filter(t => (t.type === 'BUY_IN' && !t.isSettled));
    const hasUnsettledBuyIns = unsettledBuyIns.length > 0;

    console.debug(`PlayerStats: ${player.name} - Transactions: ${transactions.length}, Totals: ${JSON.stringify(totals)}`, { unsettledBuyIns, hasUnsettledBuyIns });

    return (
        <Row className="player-stat mb-3">
            <div className="summary" onClick={() => setShowTransactionList(!showTransactionList)}>
                <Row className="summary-content d-flex align-items-center">
                    <Col xs={3} md={4} className="align-self-center">
                        <div className="player-info">
                            <span className="player-name fw-bolder">{player.name}</span>
                            {isCashedOut ? <MdOutbound className={'cash-out-indicator text-success'} /> : null}
                            {hasUnsettledBuyIns ? <MdWarning className={'cash-out-indicator text-warning'} /> : null}
                        </div>
                    </Col>
                    <Col xs={3} md={2} className="money">{formatMoney(totals.buyIn)}</Col>
                    <Col xs={3} md={2} className="money">{formatMoney(totals.cashOut)}</Col>
                    <Col xs={3} md={2} className={`fw-bold ${netColor} money`}>{formatMoney(totals.net)}</Col>
                    <Col md={2} className="d-flex justify-content-end">
                        <ButtonGroup className="w-100">
                            <Button title="Add Transaction" aria-label="Add Transaction" variant="success" onClick={handleShowAddTransaction}><Cash/></Button>
                            <Button title="Remove Player" disabled={playerHasTransactions} variant="danger"
                                    onClick={() => actions.removePlayer(player.id)}><PersonX/></Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </div>
            <TransactionList
                gameId={gameId}
                playerId={player.id}
                transactions={transactions}
                showTransactions={showTransactionList}
            />
        </Row>
    );
}
